export default "__VITE_ASSET__CYEXp52m__"